const Layout = ({children} : {children: any}) => {

  return (
    <>
      <div className="year-end-section">
        {children}
      </div>
    </>
  )
}

export default Layout